module.exports = __webpack_public_path__ + "img/grafana.24119b2c.svg";